/** API route map: URLS.Controller.EmployeeAttachment */
export const EmployeeAttachment = {
      Name: 'EmployeeAttachment/',
      GetAll: 'employee-attachments',
      Add: 'add',
      DeleteAttachment: 'delete',
};
